module.exports = __webpack_public_path__ + "img/quality_control.370c71c1.png";